import { render, staticRenderFns } from "./ReviewReport.vue?vue&type=template&id=6fd6ba5d"
import script from "./ReviewReport.vue?vue&type=script&lang=js"
export * from "./ReviewReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports